"use client";

import { useState } from "react";
import MileageHeroSection from "./index";
import MileageModal from "@components/molecules/MileageModal";
import { PAGE_TYPES } from "@constants/pageTypes";

export const MileageHeroSectionClient = (props: any) => {
  const [modalData, setModalData] = useState<{
    fuelType: string;
    transmission: string;
    count: number;
    variants: any[];
  } | null>(null);

  const handleModalOpen = (fuelType: string, transmission: string, count: number, variants: any[]) => {
    setModalData({
      fuelType,
      transmission,
      count,
      variants,
    });
  };

  const handleModalClose = () => {
    setModalData(null);
  };

  return (
    <>
      <MileageHeroSection
        {...props}
        onModalOpen={handleModalOpen}
        isMobile={props.isMobile}
      />
      
      <MileageModal
        isOpen={!!modalData}
        onClose={handleModalClose}
        title={
          modalData
            ? `Available in ${modalData.count} variant${
                modalData.count > 1 ? "s" : ""
              }`
            : "Available in number of variants"
        }
        variants={modalData?.variants || []}
        preventScoll={true}
        isSellable={props.isSellable}
        segmentPageType={PAGE_TYPES.MILEAGE_PAGE}
        segmentActionName="tap_btn_variant"
        segmentSection="Mileage page summary"
        cityName={props.cityName}
        brandName={props.carDetails.makeName}
        modelName={props.carDetails.modelName}
        carAvailability={props.carAvailability}
      />
    </>
  );
};

export default MileageHeroSectionClient;
